module.exports = __webpack_public_path__ + "static/media/undraw_Mail_sent_re_0ofv.819eb315.svg";